import RequestRegisterModal from './RequestRegisterModal';
import RequestRegisterModalForm from './RequestRegisterModalForm';

export { RequestRegisterModalForm };
export default RequestRegisterModal;
